import { useEffect } from "react";
import "./css/ContactUs.css";

import SectionMessage from "./Main/SectionMessage";

import { ReactComponent as MessageSvg } from "../assets/undraw_letter_re_8m03.svg";
import { ReactComponent as MapSvg } from "../assets/undraw_tourist_map_re_293e.svg";

import { BsTelephoneFill } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { MdLocationOn } from "react-icons/md";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="landing-contact">
      <section className="section-contact">
        <div className="landing-container">
          <div className="left">
            <h2>Get In Touch</h2>
            <ul>
              <li>
                <BsTelephoneFill
                  className="icon"
                  style={{ width: "1.5rem", fontSize: "1.1rem" }}
                />
                <span>
                  Phone: <b>+95 9797489832</b>
                </span>
              </li>
              <li>
                <MdEmail
                  className="icon"
                  style={{ width: "1.5rem", fontSize: "1.25rem" }}
                />
                <span>
                  Email: <b>physiotrack@gmail.com</b>
                </span>
              </li>
              <li>
                <MdLocationOn
                  className="icon"
                  style={{ width: "1.5rem", fontSize: "1.45rem" }}
                />
                <span>
                  Address: <b>Yangon, Myanmar</b>
                </span>
              </li>
            </ul>
          </div>
          <div className="right">
            <MapSvg />
          </div>
        </div>
      </section>
      <SectionMessage illustration={<MessageSvg />} />
    </main>
  );
}

export default ContactUs;
